import React  from 'react';
function SilverZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >الحالة</th>
          <th > النتائج</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>وجوب الزكاة	</td>
          <td>{result.silverZakatDuty === 'yes' ? 'تجب عليك الزكاة' : 'لا تجب عليك الزكاة'}</td>
        </tr>
        <tr >
          <td>نصاب زكاة الفضة</td>
          <td>{result.silverWeightThreshold} (غ) </td>
        </tr>
        <tr >
          <td>مقدار الزكاة الواجب إخراجها (من المال)</td>
          <td>{result.moneyZakatAmount} </td>
        </tr>
        <tr >
          <td>مقدار الزكاة الواجب إخراجها (من الفضة)</td>
          <td>{result.silverZakatAmount} (غ)</td>
        </tr>
      </tbody>
    </table>
  );
}
export default SilverZakatTable;
